module.exports = __webpack_public_path__ + "static/media/ccKiunalla.dfc369bd.svg";